import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
const rootElement = document.getElementById('root');
const hasHomepageCheck = rootElement.hasAttribute('data-is-homepage');
const isHomepage = hasHomepageCheck ? 
    rootElement.getAttribute('data-is-homepage') === 'true' : 
    false;
    
root.render(
  <React.StrictMode>
    <App isHomepage={isHomepage} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
